import React, { FC } from "react";

interface ClassIconProps {
  className: string;
}

const ClassIcon: FC<ClassIconProps> = ({ className }) => {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2140_1819)">
<path d="M2.83495e-06 1.05947e-05C3.23597 -0.183157 3.23597 -0.183157 4.31507 0.56544C5.24924 1.84009 5.47108 3.00392 5.80274 4.54689C5.93325 5.14437 6.06377 5.74185 6.19825 6.35743C6.32876 6.98198 6.45928 7.60653 6.59375 8.25001C6.73007 8.87456 6.86639 9.49911 7.00684 10.1426C8 14.7574 8 14.7574 8 16.5C8.46141 16.4922 8.46141 16.4922 8.93213 16.4841C10.3297 16.4633 11.7273 16.4503 13.125 16.4375C13.609 16.4291 14.0931 16.4208 14.5918 16.4121C15.0591 16.4089 15.5264 16.4057 16.0078 16.4024C16.4372 16.3971 16.8667 16.3919 17.3091 16.3865C18.6237 16.5118 19.3949 16.7838 20.5 17.5C21.576 19.114 21.6004 19.642 21.5 21.5C20.51 21.5 19.52 21.5 18.5 21.5C18.5 21.83 18.5 22.16 18.5 22.5C19.49 22.5 20.48 22.5 21.5 22.5C21.5 22.995 21.5 23.49 21.5 24C15.725 24 9.95 24 4 24C4 23.505 4 23.01 4 22.5C4.99 22.5 5.98 22.5 7 22.5C7 22.17 7 21.84 7 21.5C6.175 21.5 5.35 21.5 4.5 21.5C3.39184 18.329 2.66822 15.0873 1.9292 11.8162C1.68802 10.7523 1.44178 9.68964 1.19532 8.62696C1.04006 7.94409 0.885098 7.26115 0.730472 6.57814C0.590205 5.96357 0.449939 5.34901 0.305423 4.71583C0.0177585 3.09976 -0.0585385 1.63666 2.83495e-06 1.05947e-05ZM8.5 21.5C8.5 21.83 8.5 22.16 8.5 22.5C11.14 22.5 13.78 22.5 16.5 22.5C16.5 22.17 16.5 21.84 16.5 21.5C13.86 21.5 11.22 21.5 8.5 21.5Z" fill="#1D2E56"/>
<path d="M8 11C9.31264 10.9731 10.6247 10.9532 11.9375 10.9375C12.3107 10.9291 12.6839 10.9208 13.0684 10.9121C14.046 10.9033 15.0237 10.9484 16 11C17 12 17 12 17 14.5C14.195 14.5 11.39 14.5 8.5 14.5C8.335 13.345 8.17 12.19 8 11Z" fill="#1E2E56"/>
</g>
<defs>
<clipPath id="clip0_2140_1819">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>



  );
};

export default ClassIcon;


